import React, { useMemo } from 'react';
import t from '~t';

import { Link, useLocation } from 'react-router-dom';
import { Header } from '~co/screen/splitview/sidebar';
import { Icon, Button } from '~ui';

export default function SettingsHeader() {
  const { search } = useLocation();

  const backTo = useMemo(() => {
    const { back = '' } =
      Object.fromEntries(new URLSearchParams(search) || {});
    if (back.startsWith('/')) return back;
    return '/';
  }, [search]);

  return (
    <Header data-no-shadow>
      <Button asChild variant='ghost' title={t.s('back')}>
        <Link to={backTo}>
          <Icon name='back' />
        </Link>
      </Button>
    </Header>
  );
}
